import React, { useEffect, useState } from 'react';
import SearchInput from '../../components/Home/SearchInput/SearchInput';
import OfferImageBanner from '../../components/OfferImageBanner/OfferImageBanner';
import axios from 'axios';
import { BASE_URL } from '../../constant/api';
import OfferSection from '../../components/Home/OfferSection/OfferSection';
import { GoHomeFill } from 'react-icons/go';
import { useParams } from 'react-router-dom';
import { PiCowLight } from 'react-icons/pi';

function Offers() {
    const [products, setProducts] = useState([]);
    const [searchTerm, setSearchTerm] = useState(""); // For dynamic search term

    const { offer_id } = useParams()

    // Fetch data function
    const fetchData = async (url, setter) => {
        try {
            const response = await axios.get(url);
            const data = response.data.Data || response.data.data;
            if (data) {
                setter(data);
            }
            console.log(response);
        } catch (error) {
            console.error(`Error fetching data from ${url}:`, error);
            const errorMessage = error.response?.data?.message || "Failed to fetch data";
            console.log("Fetch data error message:", errorMessage);
        }
    };

    // Fetch special offers on mount
    useEffect(() => {
        fetchData(`${BASE_URL}/products/special-offers/${offer_id}/`, setProducts);
    }, [offer_id]);

    // Handle search term change and trigger search
    const handleSearchChange = async (e) => {
        setSearchTerm(e.target.value); // Update search term
        if (e.target.value.trim()) {
            try {
                const response = await axios.post(`${BASE_URL}/products/search/special-offers/`, {
                    search_word: e.target.value,
                });
                const data = response.data.Data || response.data.data;
                setProducts(data); // Update products based on search result
            } catch (error) {
                console.error('Search Error:', error);
            }
        } else {
            // Reset products if search term is empty
            fetchData(`${BASE_URL}/products/special-offers/`, setProducts);
        }
    };

    return (
        <>
            {/* Search Input */}
            <SearchInput
                placeholder="Search product..."
                head="Offers"
                value={searchTerm}
                onChange={handleSearchChange} 
                icon={<GoHomeFill />}
            />

            {/* Display Offer Banner for the first product */}
            {products.length > 0 && products[0].offer_banner && (
                <OfferImageBanner banner={products[0].offer_banner} />
            )}


            {/* Display Offers */}
            {products.length > 0 ? (
                    <div>
                    <div className="bg-[#E8FDE7CC] py-1">
                            <OfferSection title="Offer Sales" products={products} />
                        </div>
                    </div>
            ) : (
                <p>No offers found.</p>
            )}
        </>
    );
}

export default Offers;
